import AuthenticatedLayout from "../../Layouts/AuthenticatedLayout";
import DeleteUserForm from "./Partials/DeleteUserForm";
import UpdatePasswordForm from "./Partials/UpdatePasswordForm";
import UpdateProfileInformationForm from "./Partials/UpdateProfileInformationForm";
import { useAuth } from "../../context/AuthContext";
import { useEffect } from 'react';

export default function Edit() {
  const { user } = useAuth(); // Fetch authenticated user from context

  useEffect(() => {
    document.title = 'Προφίλ - Coffee Roast City';
}, []);

  return (
    <AuthenticatedLayout
      user={user}
      header={
        <h2 className="font-semibold text-xl text-gray-800 leading-tight">
          Προφίλ
        </h2>
      }
    >
      <div className="py-12">
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 space-y-6">
          {/* Update Profile Form */}
          <div className="p-4 sm:p-8 bg-white shadow sm:rounded-lg">
            <UpdateProfileInformationForm className="max-w-xl" />
          </div>

          {/* Update Password Form */}
          <div className="p-4 sm:p-8 bg-white shadow sm:rounded-lg">
            <UpdatePasswordForm className="max-w-xl" />
          </div>

          {/* Delete User Form */}
          <div className="p-4 sm:p-8 bg-white shadow sm:rounded-lg">
            <DeleteUserForm className="max-w-xl" />
          </div>
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
